module.exports = __webpack_public_path__ + "media/images/icon-currency-a31d5b4435324d585566d891a829db00.png";